import { useCallback } from "react";
import { useQuestionnaireStore } from "../stores/StoreProvider";
import type { OnboardingData } from "../types";

export const useQuestionnaire = () => {
  const questionnaireStore = useQuestionnaireStore();

  const submitOnboardingQuestionnaire = useCallback(
    async (data: OnboardingData) => {
      await questionnaireStore.submitFromOnboarding(data);
    },
    [questionnaireStore],
  );

  const clearQuestionnaireError = useCallback(() => {
    questionnaireStore.clearError();
  }, [questionnaireStore]);

  return {
    isSubmittingQuestionnaire: questionnaireStore.isSubmitting,
    questionnaireError: questionnaireStore.error,
    questionnaireProgress: questionnaireStore.progress,
    questionnaireSubmission: questionnaireStore.lastSubmission,
    submitOnboardingQuestionnaire,
    clearQuestionnaireError,
  };
};
